export default __webpack_public_path__ + "static/media/glass.3c07c67e.jpg";